import React, { FC, useEffect, useRef } from 'react';
import { ActiveIndicator, TabButton, TabsScroller, TabsWrapper } from './TebMenu.styles';

type TabMenuProps = {
  children: JSX.Element[];
  selectedIndex: number;
};

export const TabMenu: FC<TabMenuProps> = ({ children, selectedIndex }) => {
  const buttonsRefs = useRef([] as any);
  const tabsScrollerRef = useRef(null);

  useEffect(() => {
    buttonsRefs.current = buttonsRefs.current.slice(0, children.length);
  });

  const handleTabChange = (_, activeTabIndex, { onClick, value }) => {
    onClick(value);
  };

  const activeButton = buttonsRefs.current[selectedIndex]
    ? buttonsRefs.current[selectedIndex]
    : { offsetWidth: 0, offsetLeft: 0 };

  const indicatorWidth = activeButton.offsetWidth;

  const currentRef = tabsScrollerRef.current as any;

  const indicatorLeft = activeButton.offsetLeft - currentRef?.scrollLeft || 0;

  return (
    <TabsWrapper>
      <TabsScroller ref={tabsScrollerRef}>
        {children.map(({ props }, index) => (
          <TabButton
            id={`class-day-${index}`}
            type="button"
            onClick={({ target }) => handleTabChange(target, index, props)}
            key={props.label}
            ref={(el) => {
              buttonsRefs.current[index] = el;
            }}
            isSelected={index === selectedIndex}
          >
            {props.label}
          </TabButton>
        ))}
        <ActiveIndicator width={indicatorWidth} left={indicatorLeft} />
      </TabsScroller>
    </TabsWrapper>
  );
};
